/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API48140Req {
  
  /** 是否直接提交1提交0不提交 */
  isSubmit?: number;
  /** 计划书名 */
  planName?: string;
  /** 项目目标 */
  planTarget?: string;
  /** 是否有外部投资0没有1有 */
  isExternalInvest?: number;
  /** 外部投资比例 */
  externalInvestRate?: number;
  /** 合资必要性 */
  need4JointVenture?: string;
  /** 外部投资背景 */
  externalBackground?: string;
  /** 外部优势 ,ExternalAdvantageParams */
  externalAdvantage?: any[];
  /** 市场分析 */
  marketAnalysis?: string;
  /** 经营模式分析 */
  bizModelAnalysis?: string;
  /** 内部优势 ,InternalAdvantageParams */
  internalAdvantage?: any[];
  /** 经营模式 ,BizModelParams */
  bizModel?: any[];
  /** 可行性分析 ,FeasibilityAnalysisParams */
  feasibilityAnalysis?: any[];
  /** 流程图 ,WorkflowParams */
  workflow?: any[];
  /** 关键问题 ,KeyProblemSolutionParams */
  keyProblemSolution?: any[];
  /** 总资金 */
  totalAmount?: number;
  /** 资金项目 ,LayeredAmountParams */
  layeredAmount?: any[];
  /** 资金说明 */
  amountRemark?: string;
  /** 总人力成本 */
  totalMember?: number;
  /** 各人力成本 ,LayeredMemberParams */
  layeredMember?: any[];
  /** 其他资源 ,OtherResourceParams */
  otherResource?: any[];
  /**  */
  memberRemark?: string;
  /** 里程碑 ,MilestoneParams */
  milestone?: any[];
};



export interface API48140Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 48140 新增商业计划书

export interface IUsePostAPI48140Return {
  /** 新增商业计划书: 接口请求状态 */
  isAPI48140Loading: boolean;
  /** 新增商业计划书: 接口请求返回数据 */
  dataAPI48140: API48140Res;
  /**  新增商业计划书: 接口数据请求方法 */
  fetchAPI48140Data:  (inputs: API48140Req, config?: YWRequestConfig) => Promise<API48140Res>;
  /** 新增商业计划书: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48140 = ():IUsePostAPI48140Return => {
  let isMount = true;
  const [isAPI48140Loading, setIsAPI48140Loading] = useState(false);
  const [dataAPI48140, setDataAPI48140] = useState<API48140Res>({} as API48140Res);
  const requestUrl = `${basePath}/corp-admin/project/plan4biz/create`;

  const fetchAPI48140Data = async (inputs: API48140Req, config?: YWRequestConfig): Promise<API48140Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48140Req>) || {}) as API48140Req;
    
  
    if ( isMount ) {
      setIsAPI48140Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48140Res>(`${basePath}/corp-admin/project/plan4biz/create`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48140(res || {} as API48140Res);
        setIsAPI48140Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48140Loading(false);
      }
      return false as unknown as API48140Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48140Loading,
    dataAPI48140,
    fetchAPI48140Data,
    requestUrl,
  }
}

